import React from 'react';
import { DatePicker, DefaultButton, DateRangeType } from "office-ui-fabric-react";

export const FromToDateFilter = ({ onFromSelect, onToSelect, fromValue, toValue, onReset, }) => {
	if (fromValue !== null) {fromValue.setDate(1)};
	if (toValue !== null) {toValue.setDate(1)};

	return (
		<div>
			<span className={'filter-title'}>Filter by start date:</span>
			<div className={'flex-row'} style={{ height: "2rem", marginRight: "2rem" }}>
				<DatePicker
					className={'date-picker'}
					onSelectDate={onFromSelect}
					value={fromValue}
					showGoToToday={false}
					maxDate={new Date()}
					calendarProps={{dateRangeType: DateRangeType.Month, isDayPickerVisible:false}}
					placeholder='From'
				/>
				<span className={'filter-dash'}>-</span>
				<DatePicker
					className={'date-picker'}
					onSelectDate={onToSelect}
					value={toValue}
					showGoToToday={false}
					maxDate={new Date()}
					calendarProps={{dateRangeType: DateRangeType.Month, isDayPickerVisible:false}}
					placeholder='To'
				/>
				<DefaultButton
					text='Reset'
					className={'reset-filter-button'}
					onClick={onReset}
				/>
			</div>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/components/projectCommon/fromToDateFilter.js